import React, { useMemo, memo} from 'react';
import cn from 'classnames';
import cancel_Img from '@assets/images/GIFs/ERROR.gif';
import { getObjectValue } from '@utility/utills';
// import style from './callcenterError.module.scss';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { useSelector } from 'react-redux';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { safeJsonParse } from '@utility/helperFunction';
import { connect } from 'react-redux';

const CallCenterError = (paymentLandscapeOrientation) => {

  // Variable

  const callCenterModeUserInfo = safeJsonParse(window.sessionStorage.getItem('callCenterUserInfo'), {});
  const seatData = safeJsonParse(window.sessionStorage.getItem('seat'), {});
  const serverAppTheme = useSelector(state => state?.theme?.serverAppTheme);
  const authData = safeJsonParse(window.sessionStorage.getItem('auth'), {});
  const deviceInfo = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), false);

  const isTogo = useMemo(
    () => getObjectValue(() => seatData?.sourceType === 8, false),
    [seatData?.sourceType]
  );


  // HTML CSS Code
  return (
    <div className="col-12 h-100 w-100 px-0">
      <div className='d-flex px-3 pt-12' style={{ color: serverAppTheme?.primary_text }}>
        <div className="fs_16 fw-600 col-6 p-0 mb-1">
          {LABEL().TABLE}{' '}
          {(seatData?.stationName?.length > 8
            ? seatData?.stationName.substring(0, 9) + '...'
            : seatData?.stationName) ||
            (seatData?.name?.length > 8
              ? seatData?.name.substring(0, 9) + '...'
              : seatData?.name) ||
            seatData?.stationNumber}
        </div>
        <div className={cn('fs-20 fw-700 p-0 mb-1 d-flex justify-content-end', isTogo ? 'col-5' : 'col-6')}>
          {seatData?.number}
        </div>
      </div>
      <div style={{ color: serverAppTheme?.primary_text }}>
        <>
          <div className="row w-auto justify-content-center text-left fw-600" style={{ fontSize: '24px', color: serverAppTheme?.primary_text, paddingTop: "0.75rem" }}>
            {authData?.brandName}
          </div>
          <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
            {authData?.address1}
          </div>
          <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
            {authData?.address2}
          </div>
          <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
            {authData?.city}{" "}{authData?.state}{" "}{authData?.zipCode}
          </div>
          <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
            {authData?.countryCode === "1" ? getFormatedPhoneNumber(authData?.phoneNumber) : authData?.phoneNumber}
          </div>
        </>
      </div>
      <div className='align-items-center' style={{ color: serverAppTheme?.primary_text }}>
        <div
          className="py-2 fw-400 fs_20 h-10 align-items-center justify-content-center text-center"
          style={{
            marginTop: '20px',
          }}
        >
          <div className={cn('fs_20 pb-2')}>
            Name:<span className='fw-500 pl-1'>{callCenterModeUserInfo?.name}</span>
          </div>
          <div className={cn('fs_20 pb-2')}>
            Phone Number: <span className='fw-500 pl-1'>{callCenterModeUserInfo?.phoneNumber}</span>
          </div>
          <div className={cn('fs_20')}>
            Pickup Time: <span className='fw-500 pl-1'>{callCenterModeUserInfo?.pickupTime}</span>
          </div>
        </div>
      </div>
      <div
        className={cn("col-12 pb-2 d-flex align-items-center justify-content-center", !paymentLandscapeOrientation ? 'pt-0' : 'pt-4')} style={{ top: paymentLandscapeOrientation ? '' : '15%' }}
      >
        <img className={(paymentLandscapeOrientation ? "w-10" : "w-35")} src={cancel_Img} alt="error" />
      </div>
      <div
        className="col-12 text-center fs_24 fw-500  h-10 pt-20"
        style={{ marginTop: '36x', bottom: !paymentLandscapeOrientation ? '0' : '', position: !paymentLandscapeOrientation ? 'absolute' : '', color: serverAppTheme?.primary_text }}
      >
        {isTogo ? CUSTOM_MESSAGES().TG_YOUR_ORDER_HAS_BEEN_CANCELLED : CUSTOM_MESSAGES().CC_YOUR_ORDER_HAS_BEEN_CANCELLED}
      </div>
    </div>
  );
};


const mapStateToProps = ({payment}) => ({
    paymentLandscapeOrientation: payment.paymentLandscapeOrientation
})

const MemoizedCallCenterError = memo(CallCenterError);

export default connect(mapStateToProps)(MemoizedCallCenterError);